module.exports = __webpack_public_path__ + "img/normal-xue1.9991e3c6.png";